/**
 * @desc 分页
 */
const URL = "/rantion-mns";
import http, { updateResponse } from "@/http";
export function request(params: API.mns.messageNoticeUser.page.Params, options?: any) {
  return updateResponse(
    http(URL + `/messageNoticeUser/page`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
